import { Routes as WrapperRoutes, Route, BrowserRouter } from 'react-router-dom'
import Layout from '../components/Layout'
import Credenciais from '../components/Credenciais'
import ComponentePrivado from '../middleware/ComponentePrivado'
import Tarefas from '../pages/Tasks'
import KanbanPage from '../pages/kanban'
import DesafiosPage from '../pages/desafios'
import PlanoAcaoPage from '../pages/planoAcao'
import IndicadoresPage from '../pages/indicadores'
import Suporte from '../pages/Suporte'
import Auth from '../pages/Auth'
import UsuariosExternosPage from '../pages/usuariosExternos'
import DashboardPage from '../pages/Dashboard'

function Routes() {
    return (
        <BrowserRouter>
            <Layout>
                <WrapperRoutes>
                    <Route path='*' element={<Credenciais />} />
                    <Route path='/auth' element={<Auth />} />
                    <Route path='/tarefas' element={<ComponentePrivado><Tarefas /></ComponentePrivado>} />
                    <Route path='/kanban' element={<ComponentePrivado><KanbanPage /></ComponentePrivado>} />
                    <Route path='/desafios' element={<ComponentePrivado><DesafiosPage /></ComponentePrivado>} />
                    <Route path='/planoAcao' element={<ComponentePrivado><PlanoAcaoPage /></ComponentePrivado>} />
                    <Route path='/indicadores' element={<ComponentePrivado><IndicadoresPage /></ComponentePrivado>} />
                    <Route path='/ajuda' element={<ComponentePrivado><Suporte /></ComponentePrivado>} />
                    <Route path='/usuarios' element={<ComponentePrivado><UsuariosExternosPage /></ComponentePrivado>} />
                    <Route path='/dashboard' element={<ComponentePrivado><DashboardPage /></ComponentePrivado>} />
                </WrapperRoutes>
            </Layout>
        </BrowserRouter>
    )
}

export default Routes